import Axios from "axios"
import { sortCaret } from "../../../_metronic/_helpers";
/* const url_categories_dev = "http://localhost:5000/gt-out/us-central1/api/v1/categories"; */
const url_categories = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/regions";

export const columns = [
  {
    dataField: "name",
    text: "Categories Name",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "state",
    text: "State",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
sortCaret: sortCaret,
  }
];

export function getClients(callback) {
  Axios.get(`${url_categories}/find`)
    .then((res) => {
      callback(res.data.payload);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
          console.log(`request cancelled:${thrown.message}`)
      } else {
          console.info(thrown.message)
      }
  })
}
export function getClient(uid = "") {
  return Axios.get(`${url_categories}/find/${uid}`)

}
export function updateClient(category) {
  if (category.uid) {

    return Axios.put(`${url_categories}/update/${category.uid}`, category);
  } else {
    return Axios.post(`${url_categories}/create`, category);

  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_categories}/delete/${uid}`)
}